import { Green500, Yellow500, Red500, Orange500, N40 } from '@trello/colors';

export const DueDateColorMap = {
  overdue: Red500,
  dueSoon: Yellow500,
  dueLater: Orange500,
  done: Green500,
  na: N40,
};
